import Regist from './Regist';
import List from './List';
import List2 from './List2';
import View from './View';
import Gest from './Gest';

import { endpoints } from './Config';

const toExport = {
    regist: { endpoint: endpoints.regist, component: Regist },
    list: { endpoint: endpoints.list, component: List },
    list2: { endpoint: endpoints.list2, component: List2 },
    view: { endpoint: endpoints.view, component: View },
    gest: { endpoint: endpoints.gest, component: Gest },
    base: endpoints.base
};

export default toExport;

